import {
  ListItem,
  Paper,
  TextField,
  MenuItem,
  InputLabel,
  Grid,
  FormControl,
  Select,
  Divider,
} from "@mui/material";

export default function ChecklistDialogCard(props) {
  return (
    <Paper
      elevation={6}
      style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
    >
      {props.rows.length > 1 && (
        <Grid style={{ width: "100%", padding: 10 }} container spacing={2}>
          <Grid size={{ xs: 12, sm: 4 }}></Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormControl fullWidth>
              <InputLabel htmlFor="TypeBox">Apply to all..</InputLabel>
              <Select
                // autoFocus={idx === 0}
                // value={obs["Apply to all.."]}
                onChange={(e) => props.onChecklistTypeChange(e)}
                label="Apply to all.."
                inputProps={{
                  name: "all",
                  id: "all",
                }}
              >
                <MenuItem value={"Pre-Functional"}>Pre-Functional</MenuItem>
                <MenuItem value={"Receipt Inspection"}>
                  Receipt Inspection
                </MenuItem>
                <MenuItem value={"Pre-Functional & Receipt Inspection"}>
                  Pre-Functional & Receipt Inspection
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormControl fullWidth>
              <InputLabel htmlFor="Assigned to">Assigned to</InputLabel>
              <Select
                onChange={(e) => props.onChecklistAssignToChange(e)}
                label="Assigned to"
                inputProps={{
                  name: "all",
                  id: "all",
                }}
              >
                {["Designers", "Contractors", "Owners", "Everyone"].map(
                  (role) => (
                    <MenuItem key={role} value={role}>
                      {role}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      )}
      {props.rows.map((obs, idx) => (
        <div key={idx}>
          <Divider style={{ width: "100%" }} />
          <ListItem>
            <Grid style={{ width: "100%", padding: 2 }} container spacing={2}>
              <Grid size={{ xs: 12, sm: 4 }}>
                <FormControl fullWidth>
                  <TextField
                    label="Checklist Name"
                    id={obs.id}
                    name={obs.id}
                    value={obs.Name}
                    onChange={(e) => props.onChecklistNameChange(e)}
                  />
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="TypeBox">Checklist Type</InputLabel>
                  <Select
                    autoFocus={idx === 0}
                    value={obs["Checklist Type"]}
                    onChange={(e) => props.onChecklistTypeChange(e)}
                    label="Checklist Type"
                    inputProps={{
                      name: obs.id,
                      id: obs.id,
                    }}
                  >
                    <MenuItem value={"Pre-Functional"}>Pre-Functional</MenuItem>
                    <MenuItem value={"Receipt Inspection"}>
                      Receipt Inspection
                    </MenuItem>
                    <MenuItem value={"Pre-Functional & Receipt Inspection"}>
                      Pre-Functional & Receipt Inspection
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="Assigned to">Assigned to</InputLabel>
                  <Select
                    autoFocus={idx === 0}
                    value={obs["Assigned to"]}
                    onChange={(e) => props.onChecklistAssignToChange(e)}
                    label="Assigned to"
                    inputProps={{
                      name: obs.id,
                      id: obs.id,
                    }}
                  >
                    {["Designers", "Contractors", "Owners", "Everyone"].map(
                      (role) => (
                        <MenuItem key={role} value={role}>
                          {role}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListItem>
        </div>
      ))}
    </Paper>
  );
}
